import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getNotificationListFitler } from "./Services";



export const useGetNotifications= () => {
  return useQuery(
    [endpoints.getNotificationList],
    () => getNotificationListFitler(),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: 60000
    }
  );
};
